import { render, staticRenderFns } from "./QualificationManagement.vue?vue&type=template&id=1f9fe424&scoped=true"
import script from "./QualificationManagement.vue?vue&type=script&lang=js"
export * from "./QualificationManagement.vue?vue&type=script&lang=js"
import style0 from "./QualificationManagement.vue?vue&type=style&index=0&id=1f9fe424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-load_5a3c64a85473ede7d9205802ebc6db0e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9fe424",
  null
  
)

export default component.exports